import { Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ICareTeam } from 'src/app/interfaces/CareTeam/ICareTeam';
import { CareTeamService } from 'src/app/services/careTeam.service';
import { CareTeamExpandComponent } from '../current-care-team/care-team-expand/care-team-expand.component';
import { TranslateService } from '@ngx-translate/core';
import { SwalToastService } from 'src/app/services/swal.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-care-team-past',
  templateUrl: './care-team-past.component.html',
  styleUrls: ['./care-team-past.component.css'],
  standalone: false,
})
export class CareTeamPastComponent {
  public expandComp = CareTeamExpandComponent;

  private destroy$ = new Subject<void>();

  pastCareTeams?: ICareTeam[];
  isLoading: boolean = false;

  constructor(
    private readonly careTeamService: CareTeamService,
    private readonly translate: TranslateService,
    private readonly swalToastService: SwalToastService,
  ) {}

  ngOnInit() {
    this.careTeamService.pastCareTeamLoadingSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });

    this.careTeamService.careTeamPastDataSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: ICareTeam[]) => {
        this.pastCareTeams = data;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  revertStopFun(careTeamId: number) {
    Swal.fire({
      text: `${this.translate.instant(
        'revertPlaceholder2',
      )} ${this.translate.instant('Care Team')}?`,
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: `${this.translate.instant('Cancel')}`,
      confirmButtonText: `${this.translate.instant('Ok')}`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.careTeamService
          .revertUnassignCareTeam(careTeamId.toString())
          .subscribe({
            next: () => {
              this.swalToastService.toastSuccess(
                'Care Team reverted successfully',
              );
              this.careTeamService.getData();
            },
            error: () => {
              this.swalToastService.toastError('Unable to revert Care Team');
            },
          });
      }
    });
  }
}
